<br>
    <div class="page-wrapper bg-gra-03 p-t-45 p-b-50">
        <div  class="wrapper wrapper--w790">
            <div class="card card-5">
                <div class="card-heading">
                    <h2 class="title">S'inscrire</h2>
                </div>
                
                
                <div class="card-body">
                  
                    <form   [formGroup]="addOxygenForm" (ngSubmit)="onSubmit()" >
         
                        <div class="form-row">
                          <div class="name">Nom</div>
                          <div class="value">
                              <div class="input-group">
                                  <input formControlName="nom"  class="input--style-5" type="text" name="name">
                              </div>
                            <!--   <div *ngIf="addOxygenForm.controls['telnum'].invalid && (addOxygenForm.controls['telnum'].dirty || addOxygenForm.controls['telnum'].touched)" class="alert alert-danger">
                                <div *ngIf="addOxygenForm.controls['telnum'].errors.required">
                                    tel is required.
                              </div>
                            </div> -->
                          </div>
                      </div>
					  <div class="form-row">
						<div class="name">Prenom</div>
						<div class="value">
							<div class="input-group">
								<input formControlName="prenom"  class="input--style-5" type="text" name="prenom">
							</div>
						  <!--   <div *ngIf="addOxygenForm.controls['telnum'].invalid && (addOxygenForm.controls['telnum'].dirty || addOxygenForm.controls['telnum'].touched)" class="alert alert-danger">
							  <div *ngIf="addOxygenForm.controls['telnum'].errors.required">
								  tel is required.
							</div>
						  </div> -->
						</div>
					</div>
					<div class="form-row">
						<div class="name">Email</div>
						<div class="value">
							<div class="input-group">
								<input  (keyup)="verifemail2($event)" (change)="verifemail($event)" formControlName="email"  class="input--style-5" type="email" name="email">
							</div>
							<mat-error *ngIf="emailerror" > Email incorrect</mat-error>

						  <!--   <div *ngIf="addOxygenForm.controls['telnum'].invalid && (addOxygenForm.controls['telnum'].dirty || addOxygenForm.controls['telnum'].touched)" class="alert alert-danger">
							  <div *ngIf="addOxygenForm.controls['telnum'].errors.required">
								  tel is required.
							</div>
						  </div> -->
						</div>
					</div>
					<div class="form-row">
						<div class="name">Mot de passe</div>
						<div class="value">
							<div class="input-group">
								<input   (keyup)="verifmotdepasse2($event)" (change)="verifmotdepasse($event)" formControlName="password"  class="input--style-5" type="password" name="email">
							</div>
							<mat-error *ngIf="motdepasseerror" > Longeur minimal de mot de passe est 6 caracteres</mat-error>

						  <!--   <div *ngIf="addOxygenForm.controls['telnum'].invalid && (addOxygenForm.controls['telnum'].dirty || addOxygenForm.controls['telnum'].touched)" class="alert alert-danger">
							  <div *ngIf="addOxygenForm.controls['telnum'].errors.required">
								  tel is required.
							</div>
						  </div> -->
						</div>
					</div>
					<div class="form-row">
						<div class="name">Confirmation Mot de passe</div>
						<div class="value">
							<div class="input-group">
								<input formControlName="passwordConfirm"  class="input--style-5" type="password" name="email">
							</div>
						  <!--   <div *ngIf="addOxygenForm.controls['telnum'].invalid && (addOxygenForm.controls['telnum'].dirty || addOxygenForm.controls['telnum'].touched)" class="alert alert-danger">
							  <div *ngIf="addOxygenForm.controls['telnum'].errors.required">
								  tel is required.
							</div>
						  </div> -->
						</div>
					</div>
					
					<div *ngIf="errormsg" class="alert alert-danger" role="alert">
						{{errormsg}}
				</div><br>
              
                        <div style="text-align: center;">
                           <button *ngIf="!showSpinner"  [disabled]="!addOxygenForm.valid" class="btn btn--radius-2 btn--red" type="submit">S'inscrire</button>
                       
                           <button *ngIf="showSpinner" [disabled]="!addOxygenForm.valid" class="btn btn--radius-2 btn--red" type="submit">
							<span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
							Chargement en cours...   

						   </button>
						
						   <!--  <button *ngIf="showSpinner" class="btn btn-primary" type="button" disabled>
                                <span class="spinner-border spinner-border-sm" role="status" aria-hidden="true"></span>
                                Loading...
                              </button> --><br><br><hr>
                              <br>Vous avez un compte ? 
							  <a class="txt2" routerLink="/login" >
								Se connecter
								<i class="fa fa-long-arrow-right m-l-5" aria-hidden="true"></i>
							</a>
                        </div>
					
                    </form>
                </div>
            </div>
        </div>
    </div>
